import React from 'react';
import { Star } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div onClick={scrollToCompra} className="bg-brand-card p-4 rounded-lg border border-brand-accent/30 flex flex-col h-full hover:border-brand-accent transition-colors shadow-[0_4px_20px_rgba(0,0,0,0.5)] cursor-pointer hover:shadow-[0_4px_25px_rgba(34,197,94,0.25)]" data-id="element-271">
    <div className="flex items-center mb-3" data-id="element-272">
      <div className="w-10 h-10 bg-brand-accent text-brand-dark rounded-full flex items-center justify-center font-black text-sm mr-3 shrink-0 shadow-[0_0_10px_rgba(34,197,94,0.5)]" data-id="element-273">
        {initials}
      </div>
      <div data-id="element-274">
        <div className="flex text-brand-accent mb-0.5" data-id="element-275">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-276" />)}
        </div>
        <p className="font-black text-white text-xs md:text-sm leading-tight uppercase" data-id="element-277">
          {name}
        </p>
        <p className="text-[10px] md:text-xs text-brand-accent font-bold" data-id="element-278">
          {location}
        </p>
      </div>
    </div>
    <p className="text-gray-300 text-xs md:text-sm italic flex-grow leading-relaxed font-medium" data-id="element-279">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    initials: 'MC',
    name: 'María C.',
    location: 'Docente de Economía — Ciudad de México',
    text: 'Mis alumnos por fin dejan de hablar de apuestas y entienden cómo funciona el dinero de verdad.'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'Profesor de Secundaria — Bogotá',
    text: 'Nunca más llegué a una clase sin saber cómo explicar la inflación o el crédito de forma sencilla.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    location: 'Docente de Escuela Técnica — Santiago',
    text: 'Las planificaciones me ahorran horas. No improviso nunca más.'
  }];
  return <section className="py-4 md:py-5 px-4 bg-brand-cardAlt border-b border-brand-accent/10" data-id="element-280">
      <div className="max-w-5xl mx-auto" data-id="element-281">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-282">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-283" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'VT',
    name: 'Valeria T.',
    location: 'Docente de Economía | Lima, Perú',
    text: 'El simulador del gasto hormiga les cambió la cara a mis alumnos. Por fin entienden en qué se les va el dinero. Es el material más honesto que encontré para este tema. Lo aplico desde la primera clase y los engancha de inmediato.'
  }, {
    initials: 'CR',
    name: 'Carlos R.',
    location: 'Profesor de Secundaria | Montevideo, Uruguay',
    text: 'El Manual de Preguntas Difíciles vale por sí solo el precio del kit. Mis alumnos preguntan cosas que antes me ponían nervioso —cripto, devaluación, trading— y ahora la clase sube de nivel. Salgo con seguridad de cada encuentro.'
  }, {
    initials: 'DG',
    name: 'Daniel G.',
    location: 'Profesor de Educación Financiera | Caracas, Venezuela',
    text: 'El torneo de inversión simulada del Tomo 4 transformó el grupo más difícil que tenía. Competían entre ellos para tomar mejores decisiones. Eso no lo encontré en ningún otro material. Hoy los chicos me piden más clases.'
  }, {
    initials: 'AM',
    name: 'Ana M.',
    location: 'Docente de Ciencias Económicas | Buenos Aires, Argentina',
    text: 'La Plantilla de Planificación Anual me devolvió mis fines de semana. El año entero organizado en una tarde. No puedo creer que antes no existía algo así. Mis colegas me preguntan cómo hago para tener todo listo siempre.'
  }, {
    initials: 'SR',
    name: 'Sebastián R.',
    location: 'Profesor de Escuela Técnica | Quito, Ecuador',
    text: 'El Tomo 1 sobre Psicología del Dinero fue una bomba en mi aula. Mis alumnos descubrieron por qué gastaban sin pensar, y eso cambió la dinámica del año entero. Es el material que ojalá me hubieran dado a mí cuando era adolescente.'
  }];
  return <section className="py-5 md:py-6 px-4 bg-brand-cardAlt border-y border-brand-accent/10" data-id="element-284">
      <div className="max-w-6xl mx-auto" data-id="element-285">
        <h2 className="text-xl md:text-3xl font-black text-center mb-5 text-white uppercase tracking-tight" data-id="element-286">
          🗨️ LO QUE DICEN LOS DOCENTES QUE YA TIENEN SU KIT:
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-287">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-288" />)}
        </div>
      </div>
    </section>;
}